// extracted by mini-css-extract-plugin
export var hidden = "_nn-1";
export var visible = "_nn-0";